import React, { useEffect, useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import Footer from '../Footer/Footer';

const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false); // Tracks navbar visibility
  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // Window width for responsive design

  // Function to toggle the navbar visibility
  const toggleNavbar = () => {
    setIsNavOpen(!isNavOpen);
  };

  // Update windowWidth when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Close the navbar automatically on small screens (below 768px) when the window is resized
  useEffect(() => {
    if (windowWidth > 767) {
      setIsNavOpen(false);
    }
  }, [windowWidth]);

  return (
    <div>
      <div className="navbar d-flex justify-content-between p-3">
        <Link to={'/'}> <img src='/logo.png' alt='logo' className='logo' /></Link>

        {/* Hamburger button for small screens */}
        <button
          className="navbar-toggler d-md-none d-flex justify-content-center align-items-center"
          type="button"
          onClick={toggleNavbar}
          style={{ marginTop: '-70px', border: '1px solid white' }}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Main navbar links (hidden on mobile) */}
        <div
          className={`d-flex gap-3 ${isNavOpen ? 'd-none' : 'd-none'} d-md-flex nav_right`}
        >
          <Link to="/" className="link">Home</Link>
          <Link to="/invoice-generator" className="link">Invoice</Link>
          <Link to="/quotation-generator" className="link">Estimate</Link>
          <Link to="/payslip-generator" className="link">Payslip</Link>
        </div>
      </div>

      {/* Mobile menu when navbar is toggled */}
      {isNavOpen && windowWidth <= 767 && (
        <div className="d-flex gap-3 flex-column justify-content-center align-items-center navbar_open d-md-none">
          <Link to="/" className="text-decoration-none text-dark fs-6">Home</Link>
          <Link to="/invoice-generator" className="text-decoration-none text-dark fs-6">Invoice</Link>
          <Link to="/quotation-generator" className="text-decoration-none text-dark fs-6">Estimate</Link>
          <Link to="/payslip-generator" className="text-decoration-none text-dark fs-6">Payslip</Link>
        </div>
      )}

      {/* Outlet for Nested Routes */}
      <Outlet />

      {/* Footer Component */}
      <Footer />
    </div>
  );
};

export default Navbar;
